import { Box, Grid, Typography } from '@mui/material';

export default function DragDrop(props) {
    var gridMargin = props.gridMargin
    return (
        <Grid container spacing={4} sx={{ marginTop: "12px" }}>
            <Grid item xs={12} sm={12} md={4}>
                <Box sx={{ textAlign: 'left', paddingRight: "48px" }}>
                    <Box
                        component="img"
                        sx={{
                            display: 'flex',
                            height: "60px"
                        }}
                        alt="Illustration of small geography being pulled into a larger geography."
                        src="https://sde-resources.s3.amazonaws.com/img/algohelp.svg"
                    />
                    <Typography variant="h3">Customize metrics</Typography>
                    <Typography variant="subtitle2" color="#adaca8" sx={{ marginTop: ".75rem" }}>
                    Tailor critical evaluation metrics like enrollment, utilization, and distance to school to answer your district’s needs.
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
                <Box sx={{
                    backgroundColor: '#efefef',
                    width: "100%",
                    height: "300px",
                    borderRadius: "24px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center"
                }}
                >
                    <Typography variant="body1" color="#adaca8" sx={{ margin: "128px" }}>
                        Animation showing live mapping interface while user sets priorities, and suggested swaps update in the sidebar.
                        Utilization, distance, walk zones, grade bands, feeders, and more: no problem.
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}